import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {
  return (
    <div
      className='app-sidebar-menu flex-column-fluid'
      id='kt_app_sidebar_menu_wrapper'
      style={{flex: '1 1 auto', minHeight: 0, overflowY: 'auto'}}
    >
      <div className='app-sidebar-wrapper my-5'>
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
